/* eslint-disable */
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  actionsBox: {
    flex: 1,
    flexDirection: "row",
    display: "flex",
    right: "-5px"
  },
  actionIconButton: {
    marginRight: "unset"
  },
  duplicateButton: {
    color: theme.palette.primary.main,
    width: "1.5rem",
    height: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  deleteButton: {
    color: "white",
    backgroundColor: "#ED1867",
    borderRadius: "100%",
    width: "1.3rem",
    height: "1.3rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.8rem",
    fontWeight: "bold"
  },
  packageCardStyles: {
    flexGrow: 0,
    flexBasis: "31%",
    maxWidth: "31%",
    marginRight: "1.5%",
    cursor: "pointer",
    borderRadius: "0.8rem",
    position: "relative",
    boxShadow: "0px 3px 10px #01C7CC80",
    backgroundColor: "white",
    padding: "0.5rem 10px",
    marginTop: "1rem"
  },
  listContainer: {
    listStyle: "none",
    display: "flex",
    padding: "0"
  },
  packageName: {
    fontFamily: "Lato",
    fontSize: "14px",
    color: theme.palette.primary.main,
    textAlign: "center",
    marginLeft: "0"
  },
  headingHelper: {
    fontSize: "16px",
    color: "#003B77",
    margin: "0 0 1rem 0"
  },
}));
